import type { MechKey } from './keys';

export const ru: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Механика · 2D',
  'panel.scene': 'Сцена',
  'panel.dims': 'Параметры',
  'panel.style': 'Внешний вид',
  'panel.action': 'Управление',
  'style.body': 'Тело',
  'style.vector': 'Векторы',
  'style.ground': 'Поверхность',
  'style.forces': 'Показать силы',
  'style.trace': 'Показать след',
  'style.labels': 'Метки векторов',
  'hint.line1': 'Нажмите «Воспроизвести» для запуска · перетащите тела для перемещения',
  'hint.line2': 'Песочница: выберите фигуру, затем кликните для размещения',
  'scene.incline': 'Наклонная плоскость',
  'scene.projectile': 'Движение снаряда',
  'scene.pendulum': 'Маятник',
  'scene.springMass': 'Система пружина-груз',
  'scene.collisions': 'Столкновения',
  'scene.atwood': 'Машина Атвуда',
  'scene.circular': 'Круговое движение',
  'scene.sandbox': 'Песочница',
  'dim.angle': 'угол (°)',
  'dim.friction': 'трение',
  'dim.mass': 'масса',
  'dim.massA': 'масса A',
  'dim.massB': 'масса B',
  'dim.velocity': 'скорость',
  'dim.angleLaunch': 'угол запуска (°)',
  'dim.gravity': 'гравитация',
  'dim.gravityX': 'гравитация x',
  'dim.gravityY': 'гравитация y',
  'dim.length': 'длина',
  'dim.damping': 'затухание',
  'dim.spring': 'жёсткость',
  'dim.restitution': 'упругость',
  'dim.radius': 'радиус',
  'dim.speed': 'быстрота',
  'action.play': 'Воспроизвести',
  'action.pause': 'Пауза',
  'action.step': 'Шаг',
  'action.reset': 'Сбросить',
  'action.speed': 'Скорость',
  'action.clear': 'Очистить',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Гравитация',
  'forceName.normal': 'Нормальная сила',
  'forceName.friction': 'Сила трения',
  'forceName.tension': 'Натяжение',
  'forceName.spring': 'Сила упругости',
  'forceName.applied': 'Приложенная сила',
  'forceName.air': 'Сопротивление воздуха',
  'palette.box': 'Куб',
  'palette.circle': 'Шар',
  'palette.ramp': 'Наклонная',
  'palette.ground': 'Поверхность',
  'palette.hint': 'Выберите фигуру, затем кликните по полотну для размещения.',
  'panel.forces': 'Наблюдаемые силы',
  'forces.empty': 'Пока нет — запустите сцену',
};
